import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeProducts01 from './HomeProducts_01';
import HomeProducts02 from './HomeProducts_02';
import HomeProducts03 from './HomeProducts_03';
import HomeProducts04 from './HomeProducts_04';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-products-01' ?
                <HomeProducts01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-products-02' ?
                <HomeProducts02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-products-03' ?
                <HomeProducts03 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-products-04' ?
                <HomeProducts04 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeProducts01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
